import {Modal} from "antd";
import {useState} from "react";
import {CiCircleInfo} from "react-icons/ci";

const Confirm = ({visible,onClose,handleClick}) => {

    return (
        <Modal open={visible}
               onCancel={onClose}
               footer={null}
               className={"!w-fit"}>
            <div className={"text-center p-4"}>
                <CiCircleInfo className={"w-32 h-32 justify-center mx-auto text-yellow-400"} />
                <h2 className={"text-2xl font-semibold text-gray-700 text-center mb-2"}>Bạn muốn ứng tuyển vào công việc này không?</h2>
            </div>
            <div className={"justify-center mx-auto items-center flex flex-wrap gap-4"}>
                <button onClick={handleClick}
                        className={"bg-green-500 text-white hover:bg-green-700 text-lg transition-all font-semibold px-6 py-3 shadow-md rounded-lg"}>Đồng ý</button>
                <button className={"bg-red-500 text-white hover:bg-red-700 transition-all text-lg font-semibold px-6 py-3 shadow-md rounded-lg"} onClick={onClose}>Hủy</button>
            </div>
        </Modal>
    )
}

export default Confirm;